<template>
  <footer>
      <div class="footer-bottom">
        <div class="footer-center">
          <div class="footer-1">专业化团队，为您提供更完善的解决方案</div>
          <div class="footer-2" @click="demand">
            我要提出需求
          </div>
          <div class="footer-3"></div>
          <div class="footer-4">
            <div class="f-l">
              <img src="../assets/img/footer/logo.png" alt="">
              <p>选择我们 选择成功</p>
            </div>
            <div v-if="minWidth > 500" class="f-r">
              成都极数链科技有限公司
            </div>
          </div>
          <div class="footer-5">
            <div class="f-5-l">
              <img src="../assets/img/footer/ewnn.jpg" alt="">
            </div>
            <div v-if="minWidth < 500" class="f-r-ooo">
              成都极数链科技有限公司
            </div>
            <div class="f-5-r">
              <div class="f-1">
                <div class="f-1-1">地址：</div>
                <div class="f-1-2">成都市武侯区府城大道西段399号天府新谷10号楼9楼</div>
              </div>
              <div class="f-2">
                <div class="f-2-1">联系方式：181 9079 5870</div>
                <!-- <div class="f-2-2"><img src="../assets/img/footer/qq.png" alt=""></div>
                <div class="f-2-3"><img src="../assets/img/footer/weixin.png" alt=""></div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-5">
        <div class="f-5-r">
          <div class="f-2">
            <div class="f-2-1" ><a style="color:white;" href="https://beian.miit.gov.cn/">蜀ICP备19036902号-5</a></div>
          </div>
        </div>
      </div>
    </footer>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      minWidth:''
    }
  },
  mounted() {
    window.addEventListener('resize', this.getWidth);
    this.getWidth()
  },
  methods: {
    getWidth(){
      // this.height = window.innerWidth - 70 + 'px';
      this.minWidth = String(window.innerWidth)
      console.log('kkkk', this.minWidth)
    },
    demand() { // 跳转客服
      // window.open()
      KS.openChatWin()
    }
  },
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 500px) {
  .footer-bottom {
    width: 100%;
    padding: 120px 0px 120px 0px;
    min-width: 1200px;
    background: #12164A;
    // overflow-x:auto;
    // overflow-x:auto
    .footer-center {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .footer-1 {
        font-size: 32px;
        font-family: PingFang SC;
        font-weight: 100;
        color: #FFFFFF;
      }
      .footer-2 {
        width: 300px;
        height: 70px;
        background: #FFFFFF;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #001C3A;
        text-align: center;
        line-height: 70px;
        margin-top: 30px;
        cursor: pointer;
      }
      .footer-3 {
        width: 100%;
        height: 1px;
        background: #FFFFFF;
        margin-top: 40px;
      }
      .footer-4 {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 100px;
        .f-l {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          img {
            width: 210px;
            height: 70px;
          }
          p {
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: 100;
            color: #FFFFFF;
            margin-top: 20px;
          }
        }
        .f-r {
          font-size: 32px;
          font-family: PingFang SC;
          font-weight: 100;
          color: #FFFFFF;
          margin-left: 120px;
        }
      }
      .footer-5 {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 50px;
        .f-5-l {
          img {
            width: 210px;
            height: 210px;
          }
        }
        .f-5-r {
          margin-left: 120px;
          .f-1 {
            font-size: 20px;
            font-family: PingFang SC;
            font-weight: 100;
            color: #FFFFFF;
            opacity: 0.5;
            display: flex;
            .f-1-2 {
              width: 300px;
            }
          }
          .f-2 {
            font-size: 20px;
            font-family: PingFang SC;
            font-weight: 100;
            color: #FFFFFF;
            opacity: 0.5;
            margin-top: 50px;
            display: flex;
            align-items: center;
            .f-2-1 {

            }
            .f-2-2 {
              width: 26px;
              height: 28px;
              margin-left: 20px;
              cursor: pointer;
            }
            .f-2-3 {
              width: 29px;
              height: 24px;
              margin-left: 20px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  .footer-5 {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #12164A;
    margin-bottom: 10px;
    .f-5-l {
      img {
        width: 210px;
        height: 210px;
      }
    }
    .f-5-r {
      margin-left: 0px;
      .f-1 {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 100;
        color: #FFFFFF;
        opacity: 0.5;
        display: flex;
        .f-1-2 {
          width: 300px;
        }
      }
      .f-2 {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 100;
        color: #FFFFFF;
        opacity: 0.5;
        margin-top: 50px;
        display: flex;
        align-items: center;
        .f-2-1 {

        }
        .f-2-2 {
          width: 26px;
          height: 28px;
          margin-left: 20px;
          cursor: pointer;
        }
        .f-2-3 {
          width: 29px;
          height: 24px;
          margin-left: 20px;
          cursor: pointer;
        }
      }
    }
  }
}

@media screen and (min-width:359px) and (max-width: 500px) {
  .footer-bottom {
    width: 100%;
    padding: 60px 0px 60px 0px;
    background: #12164A;
    .footer-center {
      width: 90%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .footer-1 {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 100;
        color: #FFFFFF;
        text-align: center;
      }
      .footer-2 {
        width: 80%;
        height: 40px;
        background: #FFFFFF;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #001C3A;
        text-align: center;
        line-height: 40px;
        margin-top: 30px;
        cursor: pointer;
      }
      .footer-3 {
        width: 100%;
        height: 1px;
        background: #FFFFFF;
        margin-top: 30px;
      }
      .footer-4 {
        // display: flex;
        // justify-content: space-between;
        // align-items: center;
        margin-top: 50px;
        .f-l {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          img {
            width: 137px;
            height: 47px;
          }
          p {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 100;
            color: #FFFFFF;
            margin-top: 10px;
          }
        }
        .f-r {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 100;
          color: #FFFFFF;
          // width: 40%;
          text-align: right;
          // margin-left: 120px;
        }
      }
      .footer-5 {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        margin-top: 20px;
        width: 100%;
        .f-5-l {
          // width: 40%;
          img {
            width: 80px;
            height: 80px;
          }
        }
        .f-r-ooo {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 100;
          color: #FFFFFF;
          margin-top: 10px;
        }
        .f-5-r {
          width: 60%;
          margin-top: 15px;
          .f-1 {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 100;
            color: #FFFFFF;
            opacity: 0.5;
            display: flex;
            text-align: center;
            .f-1-2 {
              width: 70%;
            }
          }
          .f-2 {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 100;
            color: #FFFFFF;
            opacity: 0.5;
            margin-top: 20px;
            display: flex;
            align-items: center;
            .f-2-1 {

            }
            .f-2-2 {
              width: 16px;
              height: 16px;
              margin-left: 10px;
              cursor: pointer;
            }
            .f-2-3 {
              width: 20px;
              height: 16px;
              margin-left: 10px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
